import React from "react";

// Default components
import {defaultComponents} from "./../components/_default/interfaces/DefaultComponents"
import ContentRenderer from "./../components/_default/ContentRenderer"
import MetadataComponent from "./../components/_default/MetadataComponent";
import CheckNotFoundPage from "./../components/_default/CheckNotFoundPage";
import { useAppSelector, useAppDispatch } from "./../store/hooks"

window.defaultComponents = defaultComponents;

export default function Webpage371efsef() {
        const page_seo = {
                    seo_title: 'efsef - testprana.itpr.eu',
                    canonical: 'https:\/\/testprana.itpr.eu\/en\/sefessefsef',
            }
    
    const dispatch = useAppDispatch();
    
    React.useEffect(() => {
        dispatch({
            type: "SET_WEBPAGE_ACTIVE",
            payload: "019c89f4-e05e-71c6-8641-ce887c32d452"
        });
    }, [])
    
    React.useEffect(() => {
        dispatch({
            type: "UPDATE_STRUCTURE",
            payload: {"webpageComponents":[8467],"components":{"8467":{"id":8467,"uuid":"019c7a2d-1bd2-7239-9754-3c2d4e5d23d8","language_id":null,"parent_id":null,"webpage_id":371,"type":"section","sort_order":0,"version":1,"isShared":false,"attributes":{"classes":"row","content_width_unit":"%","content_width_size":100,"styles":{"paddingTop":"60px","paddingLeft":"60px","paddingRight":"60px","paddingBottom":"60px"}},"childWebpageComponentRelations":[]}}}        });
    }, [])
    
    
    
    return (
        <>
            <CheckNotFoundPage/>
            <MetadataComponent page_seo={page_seo} />
            <ContentRenderer />
        </>
    );
}